import { ThemeProvider } from '@emotion/react'
import { PropsWithChildren } from 'react'
import { theme } from '../../styled'

const StyledThemeProvider = function ({ children }: PropsWithChildren) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

export default StyledThemeProvider
